interface IOwnProps {
  title?: string;
  description?: string;
}


export const NotFound: React.FC<IOwnProps> = ({ title, description }: IOwnProps) => {
  return (
    <div className="w-100 text-center p-5">
      <div style={{ fontSize: '4em' }}>😕</div>
      <h1>{title ?? `Not Found`}</h1>
      <p>{description ?? `Sorry, we couldn't find that page.`}</p>
    </div>
  );
};